import AutoSelectAddToCartConfirmation from './AutoSelectAddToCartConfirmation';

export default AutoSelectAddToCartConfirmation;
